import { getPurchasePerformanceEvaluationIndicator } from "@/apis/supplier";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function usePerformaceEvaluationCategory() {
  const result = useQuery({
    queryKey: ["PurchasePerformanceEvaluationIndicator"],
    queryFn: () => getPurchasePerformanceEvaluationIndicator(),
  });

  return useMemo(
    () => ({
      categories: result.data?.data.data,
    }),
    [result],
  );
}
